<template lang="pug">
  // TABLE that displays CRM
  div
    p(v-if='loading')
    app-table(:data='tableItems', :label='tableFields', sortBy='timestamp', :sortDesc='true', v-else)
</template>

<script>
import { db } from '@/firebase'
// import numeral from 'numeral'

const customRef = db.ref('custom')

export default {
  name: 'crm-table-account-opening',
  data() {
    return {
      cls: {},
      loading: true,
      tableItems: [
      ],
      tableFields: {
        name: {
          label: 'Name',
        },
        phone: {
          label: 'Phone',
        },
        accountCompany: {
          label: 'Company',
        },
        address: {
          label: 'Address',
          sortable: true,
        },
        branch: {
          label: 'Branch',
          sortable: true,
        },
        timestamp: {
          label: 'Time',
          sortable: true,
        },
      },
    }
  },
  mounted: function() {
    var customs
    customRef.child('account').on('value', (snapshot) => {
      customs = []
      Object.entries(snapshot.val()).forEach(function([key, val]) {
        customs.unshift({
          name: val.name,
          phone: val.phone,
          accountCompany: val.company,
          address: val.address,
          branch: val.branch,
          timestamp: parseInt(val.timestamp),
        })
      })

      this.tableItems = customs
      this.loading = false
    })
  },
  beforeDestroy: function() {
    customRef.off('value')
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/crmTableAccountOpening.vue?22eeeaf5